// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_9j-3";
export var contentContainer = "_9j-0";
export var editorContainer = "_9j-1";
export var quillInputForm = "_9j-2";
export var zoneDivider = "_9j-4";